export const SHOW_LOADER = "[LOADER] SHOW_LOADER";
export const loaderShow = () => ({
  type: SHOW_LOADER
});

export const HIDE_LOADER = "[LOADER] HIDE_LOADER";
export const loaderHide = () => ({
  type: HIDE_LOADER
});
